// @flow
import React, { Component, Fragment } from 'react';    
import classNames from 'classnames/bind';
import { animateScroll as scroll } from 'react-scroll';

import buttonStyle from '../../../../assets/styles/button.scss';
import style from './WaysToPay.scss';

import visaLogo from '../../../../assets/img/home/ways-to-pay/visa-logo.png';
import kashioLogo from '../../../../assets/img/home/ways-to-pay/kashio-logo.png';
import bitcoinLogo from '../../../../assets/img/home/ways-to-pay/bitcoin-logo.png';
import paypalLogo from '../../../../assets/img/home/ways-to-pay/paypal-logo.png';
import amexLogo from '../../../../assets/img/home/ways-to-pay/amex-logo.png';
import masterCardLogo from '../../../../assets/img/home/ways-to-pay/mastercard-logo.png';
import { Desktop, UntilTablet } from '../../../../utils/responsive';

type Props = {  
};

type State = {  
};
 

const waysToPayList =[
    {
        img: visaLogo,
    },
    {
        img: paypalLogo,
    },
    {
        img: masterCardLogo,
    },
    {
        img: bitcoinLogo,
    },
    {
        img: kashioLogo,
    },
    {
        img: amexLogo,
    }
];

  
export default class WaysToPay extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = { 
    };
  } 

  handleClickBuyNow = () => { 
    scroll.scrollToTop();
  }

  render() {   

    return (  
        <section className={style.root}>
            <div className={style.dualWrap}>
                <div className={style.leftWrap}>
                    <div className={style.contentWrap}>
                        {waysToPayList.slice(0,3).map((item, index: number)=> (
                            <div className={style.column} key={`card-way-to-pay-${index}`} >
                                <div className={style.imageWrap}>
                                    <div><img src={item.img}/></div>
                                </div>
                                <div className={style.imageWrap}>
                                    <div>
                                        <img src={waysToPayList[index + 3].img}/>
                                    </div>
                                </div>
                            </div>
                            ))}  
                    </div>
                    <UntilTablet>
                        <button className={classNames(buttonStyle.btn, 
                            style.buttonBuyNow)} onClick={this.handleClickBuyNow}>
                            ¡Compra Ahora!
                        </button>   
                    </UntilTablet>
                </div>

                <div className={style.rightWrap}>
                    <div className={style.contentWrap}>
                        <h4>
                            Hasta 36 cuotas con tarjeta de crédito
                        </h4>
                        <span>
                            Qempo ofrece diversos métodos de pago para facilitar tus compras y darte la mejor experiencia.
                        </span>
                    </div>
                    <div>
                        <Desktop>
                            <button className={classNames(buttonStyle.btn, 
                                style.buttonBuyNow)} onClick={this.handleClickBuyNow}>
                                ¡Compra Ahora!
                            </button>   
                        </Desktop>
                    </div>
                </div>
            </div>
        </section>
    );
  }
}


WaysToPay.propTypes = { 
};
 



// WEBPACK FOOTER //
// ./src/modules/home/elements/WaysToPay/WaysToPay.jsx